import { LOGIN_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'

export default () => pushRouteClient({	routeId: LOGIN_ROUTE_ID })
